module.exports = __webpack_public_path__ + "img/教师绑定微信第二步.58a0dcf4.png";